export interface SubdomainOrgFilterConfig {
  enabled: boolean;
  baseDomain: string;
  reservedLabels: string[];
}

export class SubdomainUtils {
  public static extractSubdomainFromHostname(
    hostname: string,
    config: SubdomainOrgFilterConfig
  ): string | null {
    if (!config.enabled || !hostname) {
      return null;
    }

    const lowerHostname = hostname.toLowerCase();
    const suffix = `.${config.baseDomain.toLowerCase()}`;

    if (!lowerHostname.endsWith(suffix)) {
      return null;
    }

    const prefix = lowerHostname.slice(0, -suffix.length);

    if (!prefix || prefix.includes('.')) {
      return null;
    }

    const reservedLabels = config.reservedLabels.map(label =>
      label.toLowerCase()
    );

    if (reservedLabels.includes(prefix)) {
      return null;
    }

    return prefix;
  }
}
